module.exports = __webpack_public_path__ + "img/1471335892.a5ef3275.jpg";